<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-3"> <!-- Linke Seite (25%, col-3) -->

                <h3 class="mb-2">Select product</h3>

                <div class="row select-product-container"> <!-- Produktliste Container -->
                    <div class="col-2 product-item py-1" :class="[item==resource? 'active' : '']" v-for="item in resources" @click="selectProduct(item)" :title="item.name"> <!-- Produkt -->
                        <img :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+item.image"> <!-- Produktbild -->
                    </div>
                </div>
            </div>

            <div class="col-9"> <!-- rechte Seite(75%, col-9) -->
                <div class="row">
                    <div class="col-12"><h3>{{ resource.name }}</h3></div>
                    <div class="col-12">
                        <div id="chartdiv" style="height: 600px;"></div> <!-- Großer Chart -->
                        <div id="spark" STYLE="height: 80px; width: 300px; border: 1px solid #eee;"></div> <!-- Kurzer Sparkchart -->
                        <SparkChart resource=1 mode="7d"></SparkChart> <!-- Breiter Sparkchart -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .product-item {
        cursor: pointer;
        border-radius: 10px;
        transition: all 0.3s;

        &.active, &:hover {
            background: #42b983;
            color: #333;

        }
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    img {
        //max-width: 60px;
        width: 100%;
    }
</style>


<script>
    import * as am4core from '@amcharts/amcharts4/core';
    import * as am4charts from '@amcharts/amcharts4/charts';

    import am4themes_animated from '@amcharts/amcharts4/themes/animated';
    import SparkChart from './SparkChart';
    import ApexCharts from 'apexcharts';

    am4core.useTheme(am4themes_animated);

    function toggleAxes(ev) {
        let axis = ev.target.yAxis;
        let disabled = true;
        axis.series.each(function(series) {
            if (!series.isHiding && !series.isHidden) {
                disabled = false;
            }
        });
        axis.disabled = disabled;
    }

    export default {
        name: 'HelloWorld',
        components: {SparkChart},
        comments: {
            SparkChart,
        },
        data() {
            return {
                resources: [],
                resource: 0,
                marketdata: [],
                chart: null,
                economy: null,
            };
        },
        props: {
            msg: String,
        },
        beforeMount() {
            fetch('https://sc.gamers-universe.eu/api/getResources.php', {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                .then(response => {
                    console.log(response);
                    this.resources = response;
                }).catch(err => {
                console.log(err);
            });

          fetch('https://sc.gamers-universe.eu/api/getEconomy.php', {
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
            },
          }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
              .then(response => {
                console.log(response);
                this.economy = response;
              }).catch(err => {
            console.log(err);
          });
        },
        methods: {
            selectProduct(item) {
                this.resource = item;
            },
            create3dSpark(response) {
                var chart = am4core.create('spark', am4charts.XYChart);

                chart.padding(0, 0, 0, 0);

                chart.data = response;
                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.grid.template.disabled = true;
                dateAxis.renderer.labels.template.disabled = true;
                dateAxis.startLocation = 0.5;
                dateAxis.endLocation = 0.7;
                dateAxis.cursorTooltipEnabled = false;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                //valueAxis.min = 0;
                valueAxis.renderer.grid.template.disabled = true;
                valueAxis.renderer.baseGrid.disabled = true;
                valueAxis.renderer.labels.template.disabled = true;
                valueAxis.cursorTooltipEnabled = false;

                chart.cursor = new am4charts.XYCursor();
                chart.cursor.lineY.disabled = true;

                var series = chart.series.push(new am4charts.LineSeries());
                series.tooltipText = '{cdate}: [bold]{daymin}';
                series.dataFields.dateX = 'cdate';
                series.dataFields.valueY = 'daymin';
                series.tensionX = 0.8;
                series.strokeWidth = 2;

// render data points as bullets
                var bullet = series.bullets.push(new am4charts.CircleBullet());
                bullet.circle.opacity = 0;
                bullet.circle.propertyFields.opacity = 'opacity';
                bullet.circle.radius = 3;
            },
        },
        watch: {
            resource() {
                var me = this;
                fetch('https://sc.gamers-universe.eu/api/getHistory.php?mode=7d&id=' + this.resource.id, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then(response => {
                        me.create3dSpark(response);
                    });

                fetch('https://sc.gamers-universe.eu/api/getHistory.php?mode=a&id=' + this.resource.id, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then(response => {
                        console.log(response);
                        //return ;
                        let chartVars = [{minprice: {}}];
                        this.marketdata = response;

                        let dateData = [];
                        let valueData = [];
                        let minData = [];
                        let amountData = [];
                        _.forEach(response, function(item, key) {
                            dateData.push(item.cdate);
                            valueData.push(parseFloat(item.avgprice));
                            minData.push(parseFloat(item.minprice));
                            amountData.push(parseInt(item.amount));
                        });


                      let annotations = [];
                      _.forEach(this.economy, function(item, key) {
                        let color = null;
                        switch (item.type){
                          case "Recession":
                            color = 'rgba(255,0,0,0.3)';
                            break;
                          case "Normal":
                            color = '#ffff00';
                            break;
                          case "Boom":
                            color = '#00ff00';
                            break;
                        }
                        annotations.push({x: new Date(item.startdate).getTime(), x2: new Date(item.enddate).getTime(),fillColor: color, label: {text: item.type}})
                      });

                      console.error(annotations);

                        if (this.chart) {
                            this.chart.updateSeries([
                                {
                                    name: 'price',
                                    data: valueData,
                                },
                                {
                                    name: 'minprice',
                                    data: minData,
                                },
                                {
                                    name: 'amount',
                                    type: 'area',
                                    data: amountData,
                                }]);

                            this.chart.updateOptions({
                                yaxis: [
                                    {
                                        seriesName: 'price',
                                        forceNiceScale: true,
                                        min: Math.min(...valueData) * 0.8,
                                        max: Math.max(...valueData) * 1.05,
                                        axisTicks: {
                                            show: true,
                                        },
                                        axisBorder: {
                                            show: true,
                                        },
                                        title: {
                                            text: 'Price',
                                        },
                                    },
                                    {
                                        show: false,
                                        min: Math.min(...valueData) * 0.8,
                                        max: Math.max(...valueData) * 1.05,
                                    },
                                    {
                                        opposite: true,
                                        seriesName: 'amount',
                                        axisTicks: {
                                            show: true,
                                        },
                                        axisBorder: {
                                            show: true,
                                        },
                                        title: {
                                            text: 'Amount',
                                        },
                                        labels: {
                                            formatter: function(val, index) {
                                                return val.toFixed(0);
                                            },
                                        },
                                    },
                                ],
                            });
                            return;
                        }





                        var options = {
                            chart: {
                                type: 'line',
                                height: 550,
                                stacked: false,
                                sparkline: {
                                    enabled: false,
                                },
                                animations: {
                                    enabled: false,
                                },
                                zoom: {
                                    type: 'x',
                                    enabled: true,
                                    autoScaleYaxis: true,
                                },
                            },
                            stroke: {
                                width: 2,
                                curve: 'smooth',
                            },
                          annotations: {
                              position: 'back',
                            xaxis: annotations
                          },
                            series: [
                                {
                                    name: 'price',
                                    data: valueData,

                                },
                                {
                                    name: 'minprice',
                                    data: minData,
                                },
                                {
                                    name: 'amount',
                                    type: 'area',
                                    data: amountData,
                                }],

                            xaxis: {
                                categories: dateData,
                                type: 'datetime',
                                labels: {
                                    datetimeFormatter: {
                                        year: 'yyyy',
                                        month: 'MMM \'yy',
                                        day: 'dd MMM',
                                        hour: 'HH:mm',
                                    },
                                },
                            },
                            yaxis: [
                                {
                                    seriesName: 'price',
                                    forceNiceScale: true,
                                    min: Math.min(...valueData) * 0.8,
                                    max: Math.max(...valueData) * 1.05,
                                    axisTicks: {
                                        show: true,
                                    },
                                    axisBorder: {
                                        show: true,
                                    },
                                    title: {
                                        text: 'Price',
                                    },
                                },
                                {
                                    show: false,
                                    min: Math.min(...valueData) * 0.8,
                                    max: Math.max(...valueData) * 1.05,
                                },
                                {
                                    opposite: true,
                                    seriesName: 'amount',
                                    axisTicks: {
                                        show: true,
                                    },
                                    axisBorder: {
                                        show: true,
                                    },
                                    title: {
                                        text: 'Amount',
                                    },
                                    labels: {
                                        formatter: function(val, index) {
                                            return val.toFixed(0);
                                        },
                                    },
                                },
                            ],
                        };
                        var chart = new ApexCharts(document.querySelector('#chartdiv'), options);
                        this.chart = chart;
                        chart.render();
                    }).catch(err => {
                    console.log(err);
                });
            },
        },
    };
</script>
